import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginRoutingModule } from './login-routing.module';

import { UserLoginComponent } from './user-login/user-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { AdminLoginLayoutComponent } from 'src/app/shared/layouts/admin/admin-login-layout/admin-login-layout.component';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    SharedComponentsModule
  ],
  declarations: [
    UserLoginComponent,
    AdminLoginLayoutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ]
})
export class LoginModule { }
